<template>
    <div class="primary--text">
        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t("agarre")}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Material que constituirá la unión entre el material de revestimiento seleccionado y la superficie de colocación.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c v-model="solucionConstructiva.materialAgarre" propiedad="codigo"
                                          nombre="nombre"
                                          :items="agarres" :cargando="cargandoAgarres" @change="cambiaAgarre">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t("regularizacion")}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Su función es proporcionar planicidad dentro de unas tolerancias compatibles con la técnica de colocación.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption pa-2" v-if="solucionConstructiva.materialAgarre == null">
                    Se debe seleccionar el material de agarre antes
                </div>
                <seleccion-componente-s-c v-model="solucionConstructiva.materialRegularizacion" propiedad="codigo"
                                          nombre="nombre"
                                          :items="regularizaciones" :cargando="cargandoRegu"
                                          v-if="solucionConstructiva.materialAgarre != null || cargandoRegu">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t("impermeabilizacion")}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Esta capa es obligatoria en el caso de forjados. En el caso de explanada será recomendable si hay riesgo de heladas.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption pa-2" v-if="escenario.tipoSoporte == null || escenario.riesgoHelada == null">
                    <span v-if="escenario.tipoSoporte == null && escenario.riesgoHelada == null && !cargandoImpermeabilizaciones">
                    Se debe seleccionar el tipo de soporte y riesgo de helada del escenario antes
                    </span>
                    <span v-if="escenario.tipoSoporte == null && escenario.riesgoHelada != null && !cargandoImpermeabilizaciones">
                    Se debe seleccionar el tipo de soporte del escenario antes
                    </span>
                    <span v-if="escenario.tipoSoporte != null && escenario.riesgoHelada == null && !cargandoImpermeabilizaciones">
                    Se debe seleccionar el riesgo de helada del escenario antes
                    </span>
                </div>
                <seleccion-componente-s-c v-model="solucionConstructiva.materialImpermeabilizacion" propiedad="codigo"
                                          nombre="nombre"
                                          :items="impermeabilizaciones" :cargando="cargandoImpermeabilizaciones"
                                          v-if="(escenario.tipoSoporte != null && escenario.riesgoHelada != null)
                                          || cargandoImpermeabilizaciones"
                                          @change="cambiaAgarre">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t("desolidarizacion")}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Recomendable para independizar, a efectos mecánicos, dos capas contiguas.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <seleccion-componente-s-c v-model="solucionConstructiva.materialDesolidarizacion" propiedad="codigo"
                                          nombre="nombre"
                                          :items="desolidarizaciones" :cargando="cargandoDeso">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t("solera")}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Consiste en una losa de hormigón en masa cuyo espesor dependerá del uso previsto (únicamente peatonal o peatonal y eventualmente rodado)</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption pa-2" v-if="escenario.tipoSoporte == null || escenario.uso == null">
                    <span v-if="escenario.tipoSoporte == null && escenario.uso == null">
                    Se debe seleccionar el tipo de soporte y uso del escenario antes
                    </span>
                    <span v-if="escenario.tipoSoporte == null && escenario.uso != null">
                    Se debe seleccionar el tipo de soporte del escenario antes
                    </span>
                    <span v-if="escenario.tipoSoporte != null && escenario.uso == null">
                    Se debe seleccionar el uso del escenario antes
                    </span>
                </div>
                <seleccion-componente-s-c v-model="solucionConstructiva.materialSolera" propiedad="codigo"
                                          nombre="nombre"
                                          v-if="(escenario.tipoSoporte != null && escenario.uso != null) || cargandoSoleras"
                                          :items="soleras" :cargando="cargandoSoleras">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t("barrera_vapor")}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>Su función es evitar el tránsito de agua en sentido ascendente debido al nivel freático o a condensaciones por cambios térmicos. En el caso de explanada y riesgo de heladas, es obligatoria, aunque se recomienda su uso en cualquier caso.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption pa-2" v-if="(escenario.tipoSoporte == null || escenario.riesgoHelada == null)
                && !cargandoBarrerasVapor">
                    <span v-if="escenario.tipoSoporte == null && escenario.riesgoHelada == null">
                    Se debe seleccionar el tipo de soporte y riesgo de helada del escenario antes
                    </span>
                    <span v-if="escenario.tipoSoporte == null && escenario.riesgoHelada != null">
                    Se debe seleccionar el tipo de soporte del escenario antes
                    </span>
                    <span v-if="escenario.tipoSoporte != null && escenario.riesgoHelada == null">
                    Se debe seleccionar el riesgo de helada del escenario antes
                    </span>
                </div>
                <seleccion-componente-s-c v-model="solucionConstructiva.materialBarreraVapor" propiedad="codigo"
                                          nombre="nombre"
                                          v-if="(escenario.tipoSoporte != null && escenario.riesgoHelada != null)
                                          || cargandoBarrerasVapor"
                                          :items="barrerasVapor" :cargando="cargandoBarrerasVapor">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12" class="caption font-weight-bold">
                {{$t("zahorra")}}
                <v-tooltip right max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="primary">mdi-information</v-icon>
                    </template>
                    <span>También llamada capa anticapilar, su función es impedir el remonte de agua por lo capilares de los materiales.</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <div class="caption pa-2" v-if="escenario.tipoSoporte == null && !cargandoZahorras">
                    Se debe seleccionar el tipo de soporte del escenario antes
                </div>
                <seleccion-componente-s-c v-model="solucionConstructiva.materialZahorra" propiedad="codigo"
                                          nombre="nombre"
                                          v-if="escenario.tipoSoporte != null || cargandoZahorras"
                                          :items="zahorras" :cargando="cargandoZahorras">
                </seleccion-componente-s-c>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import SeleccionComponenteSC from "../../Componentes/SeleccionComponenteSC";

    export default {
        name: "ComponentesVertical",
        components: {SeleccionComponenteSC},
        model: {
            prop: 'correcto',
            event: 'change'
        },
        props: {
            solucionConstructiva: {type: Object, required: true},
            escenario: {type: Object, required: true},
            correcto: {type: Boolean, default: false},
        },
        data: function () {
            return {
                cargandoAgarres: false,
                agarres: [],
                cargandoImpermeabilizaciones: false,
                impermeabilizaciones: [],
                cargandoRegu: false,
                regularizaciones: [],
                cargandoDeso: false,
                desolidarizaciones: [],
                cargandoSoleras: false,
                soleras: [],
                cargandoBarrerasVapor: false,
                barrerasVapor: [],
                cargandoZahorras: false,
                zahorras: []
            }
        },
        mounted() {
            Promise.all([
                this.cargarAgarres(),
                this.cargarImpermeabilizaciones(),
                this.cargarRegularizaciones(),
                this.cargarDesolidarizaciones(),
                this.cargarSoleras(),
                this.cargarBarrerasVapor(),
                this.cargarZahorras()
            ]).then(() => {
                this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
            });
        },
        watch: {
            escenario: {
                handler() {
                    Promise.all([
                        this.cargarImpermeabilizaciones(),
                        this.cargarSoleras(),
                        this.cargarBarrerasVapor(),
                        this.cargarZahorras()
                    ]).then(() => {
                        this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                    });
                },
                deep: true
            },
            solucionConstructiva: {
                handler() {
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                },
                deep: true
            }
        },
        methods: {
            emitirCorrecto(value) {
                this.$emit('change', value);
            },
            cargarAgarres() {
                return new Promise((resolve) => {
                    this.agarres = [];

                    this.cargandoAgarres = true;
                    let url = `obra-nueva/urbano/solucion-constructiva/${this.solucionConstructiva.id}/agarre`;
                    HttpHelper.get(url).then(data => {
                        this.agarres = data;
                        this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                        resolve()
                    }).finally(() => {
                        this.cargandoAgarres = false;
                    });
                });
            },
            cargarImpermeabilizaciones() {
                this.impermeabilizaciones = [];
                if (this.escenario.tipoSoporte == null) return;
                if (this.escenario.riesgoHelada == null) return;

                let params = {
                    riesgoHelada: this.escenario.riesgoHelada.codigo,
                    tipoSoporte: this.escenario.tipoSoporte.codigo
                };
                let url = `obra-nueva/urbano/solucion-constructiva/${this.solucionConstructiva.id}/impermeabilizacion`;
                this.cargandoImpermeabilizaciones = true;
                let promise = HttpHelper.get(url, params);
                promise.then(data => {
                    this.impermeabilizaciones = data;

                    if (this.solucionConstructiva.materialImpermeabilizacion == null) return;

                    let encontrada = false;
                    data.forEach((impermeabilizacion) => {
                        if (impermeabilizacion != null && impermeabilizacion.codigo ==
                            this.solucionConstructiva.materialImpermeabilizacion.codigo)
                            encontrada = true;
                    });
                    if (!encontrada) {
                        this.solucionConstructiva.materialImpermeabilizacion = null;
                    }
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                }).finally(() => {
                    this.cargandoImpermeabilizaciones = false;
                });

                return promise;
            },
            cargarRegularizaciones() {
                this.regularizaciones = [];
                if (this.solucionConstructiva.materialAgarre == null) return;

                let params = {
                    codMaterialAgarre: this.solucionConstructiva.materialAgarre.codigo
                };
                let url = `obra-nueva/urbano/solucion-constructiva/${this.solucionConstructiva.id}/regularizacion`;
                let promise = HttpHelper.get(url, params);
                this.cargandoRegu = true;
                promise.then(data => {
                    this.regularizaciones = data;

                    if (this.solucionConstructiva.materialRegularizacion == null) return;

                    let encontrada = false;
                    data.forEach((regularizacion) => {
                        if (regularizacion != null && regularizacion.codigo
                            == this.solucionConstructiva.materialRegularizacion.codigo)
                            encontrada = true;
                    });
                    if (!encontrada) {
                        this.solucionConstructiva.materialRegularizacion = null;
                    }
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                }).finally(() => {
                    this.cargandoRegu = false;
                });

                return promise;
            },
            cargarDesolidarizaciones() {
                this.desolidarizaciones = [];

                let url = `obra-nueva/urbano/solucion-constructiva/${this.solucionConstructiva.id}/desolidarizacion`;
                let promise = HttpHelper.get(url);
                this.cargandoDeso = true;
                promise.then(data => {
                    this.desolidarizaciones = data;

                    if (this.solucionConstructiva.materialDesolidarizacion == null) return;

                    let encontrada = false;
                    data.forEach((regularizacion) => {
                        if (regularizacion != null && regularizacion.codigo
                            == this.solucionConstructiva.materialDesolidarizacion.codigo)
                            encontrada = true;
                    });
                    if (!encontrada) {
                        this.solucionConstructiva.materialDesolidarizacion = null;
                    }
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                }).finally(() => {
                    this.cargandoDeso = false;
                });

                return promise;
            },
            cargarSoleras() {
                this.soleras = [];
                if (this.escenario.tipoSoporte == null) return;
                if (this.escenario.uso == null) return;

                let params = {
                    uso: this.escenario.uso.codigo,
                    tipoSoporte: this.escenario.tipoSoporte.codigo
                };
                let url = `obra-nueva/urbano/solucion-constructiva/${this.solucionConstructiva.id}/solera`;
                let promise = HttpHelper.get(url, params);
                this.cargandoSoleras = true;
                promise.then(data => {
                    this.soleras = data;

                    if (this.solucionConstructiva.materialSolera == null) return;

                    let encontrada = false;
                    data.forEach((solera) => {
                        if (solera != null && solera.codigo ==
                            this.solucionConstructiva.materialSolera.codigo)
                            encontrada = true;
                    });
                    if (!encontrada) {
                        this.solucionConstructiva.materialSolera = null;
                    }
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                }).finally(() => {
                    this.cargandoSoleras = false;
                });

                return promise;
            },
            cargarBarrerasVapor() {
                this.barrerasVapor = [];
                if (this.escenario.tipoSoporte == null) return;
                if (this.escenario.riesgoHelada == null) return;

                let params = {
                    riesgoHelada: this.escenario.riesgoHelada.codigo,
                    tipoSoporte: this.escenario.tipoSoporte.codigo
                };
                let url = `obra-nueva/urbano/solucion-constructiva/${this.solucionConstructiva.id}/barrera-vapor`;
                let promise = HttpHelper.get(url, params);
                this.cargandoBarrerasVapor = true;
                promise.then(data => {
                    this.barrerasVapor = data;

                    if (this.solucionConstructiva.materialBarreraVapor == null) return;

                    let encontrada = false;
                    data.forEach((impermeabilizacion) => {
                        if (impermeabilizacion != null && impermeabilizacion.codigo ==
                            this.solucionConstructiva.materialBarreraVapor.codigo)
                            encontrada = true;
                    });
                    if (!encontrada) {
                        this.solucionConstructiva.materialBarreraVapor = null;
                    }
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                }).finally(() => {
                    this.cargandoBarrerasVapor = false;
                });

                return promise;
            },
            cargarZahorras() {
                this.zahorras = [];
                if (this.escenario.tipoSoporte == null) return;

                let params = {
                    tipoSoporte: this.escenario.tipoSoporte.codigo
                };
                let url = `obra-nueva/urbano/solucion-constructiva/${this.solucionConstructiva.id}/zahorra`;
                let promise = HttpHelper.get(url, params);
                this.cargandoZahorras = true;
                promise.then(data => {
                    this.zahorras = data;

                    if (this.solucionConstructiva.materialZahorra == null) return;

                    let encontrada = false;
                    data.forEach((impermeabilizacion) => {
                        if (impermeabilizacion != null && impermeabilizacion.codigo ==
                            this.solucionConstructiva.materialZahorra.codigo)
                            encontrada = true;
                    });
                    if (!encontrada) {
                        this.solucionConstructiva.materialZahorra = null;
                    }
                    this.emitirCorrecto(this.solucionConstructivaEsCorrecta(this.solucionConstructiva));
                }).finally(() => {
                    this.cargandoZahorras = false;
                });

                return promise;
            },
            cambiaAgarre() {
                this.cargarRegularizaciones();
            },
            solucionConstructivaEsCorrecta(solucionConstructiva) {
                if (solucionConstructiva.materialAgarre == null) {
                    return false;
                }

                if (!this.materialValido(this.impermeabilizaciones, solucionConstructiva.materialImpermeabilizacion)) {
                    return false;
                }

                if (!this.materialValido(this.regularizaciones, solucionConstructiva.materialRegularizacion)) {
                    return false;
                }

                if (!this.materialValido(this.desolidarizaciones, solucionConstructiva.materialDesolidarizacion)) {
                    return false;
                }

                if (!this.materialValido(this.soleras, solucionConstructiva.materialSolera)) {
                    return false;
                }

                if (!this.materialValido(this.barrerasVapor, solucionConstructiva.materialBarreraVapor)) {
                    return false;
                }

                if (!this.materialValido(this.zahorras, solucionConstructiva.materialZahorra)) {
                    return false;
                }

                return true;
            },
            materialValido(materiales, material) {
                let valido = false;

                materiales.forEach((mat) => {
                    if (mat == null && material == null) {
                        valido = true;
                    } else if (mat != null && material != null && mat.codigo == material.codigo)
                        valido = true;
                });

                return valido;
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "agarre": "Agarre",
    "impermeabilizacion": "Impermeabilización",
    "regularizacion": "Regularización",
    "desolidarizacion": "Desolidarizacion",
    "solera": "Solera",
    "barrera_vapor": "Barrera de vapor",
    "zahorra": "Zahorra"
    }
    }
</i18n>
<!--@formatter:on-->